import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Icon from 'components/common/Icon/Icon'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import {
  VEHICLE_NAME_PLACEHOLDER,
  MILEAGE_PLACEHOLDER,
  ADD_VEHICLE_BUTTON_LABEL
} from 'components/MyGarage2.0/constants'
import { MILEAGE_METRIC } from 'constant'
import {
  VehicleNickname,
  MileageWrapper,
  MileageIcon,
  MileageValueWrapper,
  MileageValue,
  MileageEntity,
  ActionButton
} from '../../../SharedStyles'

const EmptyActiveVehiclePlaceholder = ({ handleAddNewVehicle }) =>
  <Wrapper>
    <VehicleNickname>
      { VEHICLE_NAME_PLACEHOLDER }
    </VehicleNickname>
    <VehicleImageTemplate asset="garage-active-vehicle-placeholder" />
    <MileageWrapper>
      <MileageIcon asset="speedometer-grey" />
      <MileageValueWrapper>
        <MileageValue>
          { MILEAGE_PLACEHOLDER }
        </MileageValue>
        <MileageEntity>
          { MILEAGE_METRIC }
        </MileageEntity>
      </MileageValueWrapper>
    </MileageWrapper>
    <ActionButton
      data-at-add-a-vehicle-button
      full
      narrow
      onClick={ handleAddNewVehicle }>
      { ADD_VEHICLE_BUTTON_LABEL }
    </ActionButton>
  </Wrapper>

export default EmptyActiveVehiclePlaceholder

EmptyActiveVehiclePlaceholder.propTypes = {
  handleAddNewVehicle: PropTypes.func
}

const Wrapper = styled.div`
  grid-area: EmptyActiveVehiclePlaceholder;
  padding: 78px 73px;
  background: ${Theme.colors.white};
  border: 1px solid ${Theme.colors.light_grey};
  border-radius: 4px;
  text-align: center;
  ${Media.mobile`
    padding: 32px 20px;
  `}
`

const VehicleImageTemplate = styled(Icon)`
  max-width: 300px;
  width: 100%;
  height: 90px;
  margin-bottom: 46px;
`
